// extracted by mini-css-extract-plugin
export default {"cls1":"RelatedPapers-cls1_jMK","cls2":"RelatedPapers-cls2_qZm RelatedPapers-cls1_jMK"};